/** needs_ai_draft 时计划条 body 短文案（数据层占位；UI 消息区不展示） */
export const NEEDS_AI_DRAFT_BODY = "待 AI 成稿 / 待编排";

/** 旅程触达条：任务（手册意图）与真实客户消息的展示判定 */
export type JourneyTouchDisplay = {
  /** 运营看的执行说明；无则不展示任务区 */
  taskText: string | null;
  /** 真实客户正文；无真实稿时为空串 */
  messageText: string;
  /** 是否渲染「消息」区：仅有真实客户稿时为 true */
  showMessage: boolean;
  /** true = 尚未成稿 / 无真实客户稿（与 showMessage 互斥） */
  messageIsPlaceholder: boolean;
};

/**
 * 拆分「任务」与「消息」。
 * 未成稿或消息与手册实质相同时：不展示消息区（不把 instruction / 占位短句塞进消息位）。
 */
export function formatJourneyTouchDisplay(opts: {
  instruction?: string | null;
  /** 真实客户文案（OutboundMessage.content / cohort 模板 / 已成稿 draft） */
  messageContent?: string | null;
  needsAiDraft?: boolean;
}): JourneyTouchDisplay {
  const taskText = (opts.instruction ?? "").trim() || null;
  const message = (opts.messageContent ?? "").trim();

  const hasRealMessage =
    !opts.needsAiDraft &&
    Boolean(message) &&
    message !== NEEDS_AI_DRAFT_BODY &&
    message !== (taskText ?? "");

  if (hasRealMessage) {
    return {
      taskText,
      messageText: message,
      showMessage: true,
      messageIsPlaceholder: false,
    };
  }

  return {
    taskText,
    messageText: "",
    showMessage: false,
    messageIsPlaceholder: true,
  };
}

/** 从计划步 id / 节点 id 查找手册执行说明（供出站条补任务区） */
export function lookupTouchInstruction(
  refs: {
    journey_plan_step_id?: number | null;
    journey_node_id?: number | null;
  },
  maps: {
    byStepId?: ReadonlyMap<number, string> | Record<number, string>;
    byNodeId?: ReadonlyMap<number, string> | Record<number, string>;
  },
): string | null {
  const fromMap = (
    map: ReadonlyMap<number, string> | Record<number, string> | undefined,
    id: number | null | undefined,
  ): string | null => {
    if (id == null || map == null) return null;
    const raw =
      map instanceof Map ? map.get(id) : (map as Record<number, string>)[id];
    const text = (raw ?? "").trim();
    return text || null;
  };

  return (
    fromMap(maps.byStepId, refs.journey_plan_step_id) ??
    fromMap(maps.byNodeId, refs.journey_node_id) ??
    null
  );
}
